import PanelUsers from "../components/Dashboard/Users/PanelUsers/PanelUsers.vue";
import PanelUser from "../components/Dashboard/Users/PanelUsers/PanelUser.vue";
import PanelUserDetail from "../components/Dashboard/Users/PanelUsers/PanelUserDetail.vue";
import LockedUsersManagement from "../components/Dashboard/Users/LockedUsersManagement/LockedUsersManagement.vue";

const panelUserRoutes = [
  {
    path: "users/panelUsers",
    component: PanelUsers,
    meta: {
      required: true,
    },
    roles: ["PanelUser", "PanelVenueUser"],
    name: "PanelUsers",
  },
  {
    path: "users/panelUser",
    component: PanelUser,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "PanelUser",
  },
  {
    path: "users/panelUser/:id",
    component: PanelUserDetail,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "PanelUserDetail",
  },
  {
    path: "users/LockedUsersManagement",
    component: LockedUsersManagement,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "LockedUsersManagement",
  },
];

export default panelUserRoutes;